module.exports = __webpack_public_path__ + "static/media/download.3d8f7ab9.svg";